import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

/** Yellow progress bar fixed at the top of the viewport. */
export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 110,
        damping: 24,
        restDelta: 0.001,
    });

    return (
        <motion.div
            data-testid="scroll-progress-bar"
            aria-hidden
            className="fixed top-0 left-0 right-0 h-[3px] origin-left bg-yellow z-[60] pointer-events-none"
            style={{ scaleX }}
        />
    );
}
